import XButton from '../common/XButton';
import { sectionTitleClasses } from '../common/formClasses';
import { cn } from '../../utils/classNames';
import { TOUR_TARGETS } from '../../constants/tourTargets';
import { heroEscapeHatchClasses, heroSubtitleClasses } from './easyModeClasses';

const EasyModeHero = ({ isClassicIntakeVisible = false, onGoToClassicIntake }) => (
  <div>
    <h1 className={cn(sectionTitleClasses, 'mb-0!')}>Let&rsquo;s build your demand.</h1>
    <p className={heroSubtitleClasses}>
      Start with the case intake. Then, drop every document you have for the case for AI Demand Pro
      to classify each one, flag what&rsquo;s missing, and draft your demand.
    </p>
    {isClassicIntakeVisible && (
      <p className={heroEscapeHatchClasses} data-tour={TOUR_TARGETS.EASY_MODE_CLASSIC_INTAKE}>
        Want more control over the details?
        <XButton variant="link" onClick={onGoToClassicIntake}>
          Go to Classic Intake
        </XButton>
      </p>
    )}
  </div>
);

export default EasyModeHero;
